import { getBaseRole } from '@/helpers/customRoles';
import { selectIsAuth, selectProfile } from '@store/profile.reducer'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

export default function useDefaultAuthRedirect() {
  const profile = useSelector(selectProfile)
  const isAuth = useSelector(selectIsAuth)
  const history = useHistory()
  const setCustomStudentLoginHomePageStore = useSelector(
    (store: any) => store.settings.isCustomStudentLoginHomePage,
  )

  const studentLoginHomePageStore = useSelector(
    (store: any) => store.settings.studentLoginHomePage,
  )
  // Проверяем, не делали ли уже редирект
  const childrenDefaultRedirectDone = localStorage.getItem('childrenDefaultRedirectDone')

  const allow = isAuth && 
      studentLoginHomePageStore && 
      setCustomStudentLoginHomePageStore == '1' && 
      getBaseRole(profile?.role) === 'children' &&
      window.location.pathname === '/' &&
      window.location.pathname !== studentLoginHomePageStore && 
      !childrenDefaultRedirectDone

  const handleLoginDestination = () => {
    if(!allow) return;
      localStorage.setItem('childrenDefaultRedirectDone', 'true')
      history.replace(studentLoginHomePageStore)
      return
  }

  useEffect(() => {
    if (allow) {
        handleLoginDestination()
    }
  }, [allow])
}
